/*
 * product-zoom.js — Zoom immagini della pagina prodotto (PhotoSwipe v5).
 * Inizializza PhotoSwipe come lightbox fullscreen sulla galleria PDP: click/tap su
 * un'immagine apre il visore con zoom (pinch su mobile, wheel/click su desktop) e swipe
 * tra le immagini. Le URL delle librerie (self-hosted in /assets) arrivano via data-*
 * dal container `[data-pswp-gallery]`, così nessun path e nessun inline script.
 * Modulo ESM: caricato con <script type="module"> solo sul template prodotto.
 *
 * IMPORTANTE: `[data-pswp-gallery]` deve stare sull'elemento <main-product> (persistente),
 * NON sulla <theme-swiper> della galleria. Al cambio variante main-product.js rimpiazza
 * l'innerHTML di <main-product>, distruggendo la galleria: agganciando PhotoSwipe
 * all'elemento persistente, la delega del click sopravvive e i figli vengono ri-letti a
 * ogni click (nuovi <a data-pswp> dopo il refresh). Spostarlo sulla galleria rompe lo zoom
 * dopo il cambio variante.
 */
(async () => {
  const gallery = document.querySelector('[data-pswp-gallery]');
  if (!gallery) return;

  const { default: PhotoSwipeLightbox } = await import(gallery.dataset.pswpLightboxLib);

  const lightbox = new PhotoSwipeLightbox({
    gallery,
    // Esclude gli slide clonati da Swiper (loop) per non duplicare le immagini nel visore.
    children: '.swiper-slide:not(.swiper-slide-duplicate) a[data-pswp]',
    pswpModule: () => import(gallery.dataset.pswpLib),
    // Chiusura con swipe verso il basso su mobile.
    closeOnVerticalDrag: true,
    bgOpacity: 0.9,
  });

  lightbox.init();
})();
